export default {
  title: 'List of third-party invoices (Expenses paid)',
  rejectedBill: 'Rejected invoice',
  caixaRestriction: 'Bankia/CaixaBank does not allow the association of third party expenses for this invoice'
}
